import { render, staticRenderFns } from "./Mango.vue?vue&type=template&id=678a09d0"
import script from "./Mango.vue?vue&type=script&lang=js"
export * from "./Mango.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports